import Button from '@/components/Button/index'
import { useTranslation } from 'react-i18next'

export default function ReceipientSwitch({ selected, imageUrl, onClick, title }) {
	const { t } = useTranslation()

	return (
		<div className="eclip-receipient">
			<div className="eclip-receipient__title">{title}</div>
			<div className="eclip-receipient__selected">
				<div className="eclip-receipient_container">
					{selected ? (
						<>
						<div
							className="eclip-receipient__icon"
							style={{ backgroundImage: imageUrl }}
						></div>
						<div className="eclip-receipient__name">{selected?.name}</div>
						</>
					) : (
						<div className="eclip-receipient__no_name">No recipient added</div>
					)}
				</div>
				{typeof onClick === 'function' && (
				<div className="eclip-receipien__change">
					<Button
						text={selected ? t('Change') : t('addRecipient')}
						sizing="Cancel"
						full
						ghost
						submit={() => {
							onClick()
						}}
					/>
				</div>
				)}
			</div>
		</div>
	)
}
